const goodsList = {
	state : {
		checkedGoodsList : [],
		searchGoodsObj: {}
	},

	mutations: {
		GET_LIST: (state,checkedGoodsList) => {
			state.checkedGoodsList = checkedGoodsList;
		}
	}
}

export default goodsList;


// WEBPACK FOOTER //
// ./src/store/modules/goodsList.js